import { ArrowLeft, LockKeyhole } from 'lucide-react';
import { Link } from 'react-router-dom';

export function UnauthorizedPage() {
  return <div className="system-page"><LockKeyhole size={38} /><h1>Access not allowed</h1><p>Aa module mate tamne permission aapel nathi.</p><Link className="button primary" to="/"><ArrowLeft size={17} /> Dashboard</Link></div>;
}

export function NotFoundPage() {
  return <div className="system-page"><strong className="error-code">404</strong><h1>Page not found</h1><p>Requested admin page available nathi.</p><Link className="button primary" to="/"><ArrowLeft size={17} /> Dashboard</Link></div>;
}
